export const BUTTON_STATE = {
	DEFAULT: "DEFAULT",
	HOVER:"HOVER",
	ACTIVE:"ACTIVE",
	DISABLED:"DISABLED",
};
